import React, { useEffect, useState } from "react";
import { Progress } from "antd";
import StatCard from "./StatCard";
import { getAnalyticsApi } from "../../services/api";

export default function Analytics() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = async () => {
      const res = await getAnalyticsApi();
      setData(res.data);
    };
    load();
  }, []);

  const revenueData = data?.monthlyRevenue || [];
  const categoryRevenue = data?.categoryRevenue || [];

  const maxRev = Math.max(...revenueData.map(b => b.rev || 0), 1);

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Analytics</div>
          <div className="page-sub">Performance overview — last 6 months</div>
        </div>
      </div>

      {/* STATS */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <StatCard label="TOTAL REVENUE" value={`₹${data?.totalRevenue || 0}`} delta="22% YoY" positive />
        <StatCard label="TOTAL ORDERS" value={data?.totalOrders || 0} delta="18% YoY" positive />
        <StatCard label="CONVERSION RATE" value={`${data?.conversionRate || 0}%`} delta="0.4% vs last year" positive />
        <StatCard label="RETURN RATE" value={`${data?.returnRate || 0}%`} delta="0.8% better" positive />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 16 }}>

        {/* MONTHLY REVENUE */}
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid rgba(0,0,0,0.08)', padding: 20 }}>
          <div className="section-title">Monthly Revenue</div>

          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, height: 180, paddingTop: 8 }}>
            {revenueData.map(b => (
              <div key={b.month} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
                
                <div style={{ fontSize: 11, color: '#888', fontWeight: 500 }}>
                  ₹{Math.round((b.rev || 0) / 1000)}K
                </div>

                <div
                  style={{
                    width: '100%',
                    background: b.month === 'Apr' ? '#534ab7' : '#eeedfe',
                    borderRadius: 6,
                    height: `${Math.round(((b.rev || 0) / maxRev) * 130)}px`,
                    transition: 'height .3s'
                  }}
                />

                <div style={{ fontSize: 12, color: '#888' }}>{b.month}</div>
              </div>
            ))}
          </div>
        </div>

        {/* CATEGORY */}
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid rgba(0,0,0,0.08)', padding: 20 }}>
          <div className="section-title">Revenue by Category</div>

          {categoryRevenue.map(c => (
            <div key={c.name} style={{ marginBottom: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                <span style={{ fontSize: 13, color: '#888' }}>{c.name}</span>
                <span style={{ fontSize: 13, fontWeight: 500 }}>{c.pct}%</span>
              </div>

              <Progress
                percent={c.pct}
                showInfo={false}
                strokeColor={c.color}
                trailColor="rgba(0,0,0,0.06)"
                size="small"
              />
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
